import { css } from 'aphrodite';
import * as React from 'react';
import { Skeleton } from '../../../../web/components-v2/Skeleton';
import { SparklesIcon } from '../../../../web/components/svgs/icons/SparklesIcon';
import type { AssistantStats } from './reportsPresentation';
import { reportsStyles as rs } from './styles/reportsStyles';

interface AssistantImpactCardProps {
	stats?: AssistantStats;
	rangeLabel: string;
	isLoading?: boolean;
}

/** The "Support Agent" impact band — AI drafting metrics for the period. */
export const AssistantImpactCard: React.FC<AssistantImpactCardProps> = ({ stats, rangeLabel, isLoading }) => {
	const cells = [
		{ label: 'Drafts generated', value: stats?.draftsGenerated ?? '—', valueStyle: rs.assistantStatPrimary },
		{ label: 'Draft acceptance', value: stats?.acceptanceRate ?? '—', valueStyle: rs.assistantStatSecondary },
		{ label: 'Coverage', value: stats?.coverage ?? '—', valueStyle: rs.assistantStatTertiary },
		{ label: 'Avg. confidence', value: stats?.averageConfidence ?? '—', valueStyle: rs.assistantStatSuccess },
	];

	return (
		<section className={css(rs.assistantBand)}>
			<div className={css(rs.assistantInner)}>
				<div className={css(rs.assistantHeader)}>
					<span className={css(rs.assistantBadge)}>
						<SparklesIcon width={18} height={18} />
					</span>
					<h2 className={css(rs.assistantTitle)}>Support Agent impact</h2>
					{!isLoading && stats && stats.coveragePercent != null && (
						<span className={css(rs.assistantPill)}>Drafted replies on {stats.coveragePercent}% of conversations</span>
					)}
					<span className={css(rs.assistantHint)}>{rangeLabel}</span>
				</div>
				<div className={css(rs.assistantStatsGrid)}>
					{cells.map(cell =>
						isLoading ? (
							<Skeleton key={cell.label} styles={[rs.assistantStatCell]}>
								<span className={css(rs.assistantStatLabel, rs.skeletonText)}>{cell.label}</span>
								<span className={css(rs.assistantStatValue, rs.skeletonText)}>—</span>
							</Skeleton>
						) : (
							<div key={cell.label} className={css(rs.assistantStatCell)}>
								<span className={css(rs.assistantStatLabel)}>{cell.label}</span>
								<span className={css(rs.assistantStatValue, cell.valueStyle)}>{cell.value}</span>
							</div>
						)
					)}
				</div>
			</div>
		</section>
	);
};
